export default __webpack_public_path__ + "static/media/home.f981ee9d.svg";